/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CountStat } from './CountStat';
import {
    CountStatFromJSON,
    CountStatFromJSONTyped,
    CountStatToJSON,
    CountStatToJSONTyped,
} from './CountStat';

/**
 * 
 * @export
 * @interface PaginatedCountStatList
 */
export interface PaginatedCountStatList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCountStatList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCountStatList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCountStatList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<CountStat>}
     * @memberof PaginatedCountStatList
     */
    results: Array<CountStat>;
}

/**
 * Check if a given object implements the PaginatedCountStatList interface.
 */
export function instanceOfPaginatedCountStatList(value: object): value is PaginatedCountStatList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedCountStatListFromJSON(json: any): PaginatedCountStatList {
    return PaginatedCountStatListFromJSONTyped(json, false);
}

export function PaginatedCountStatListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedCountStatList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(CountStatFromJSON)),
    };
}

  export function PaginatedCountStatListToJSON(json: any): PaginatedCountStatList {
      return PaginatedCountStatListToJSONTyped(json, false);
  }

  export function PaginatedCountStatListToJSONTyped(value?: PaginatedCountStatList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(CountStatToJSON)),
    };
}

